"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = Select;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const styled_components_1 = __importDefault(require("styled-components"));
const SelectTag_1 = require("@src/components/elements/SelectTag/SelectTag");
const StyledSelect = (0, styled_components_1.default)(antd_1.Select) `
	.ant-select-selection-item-remove {
		display: flex;
		align-items: center;
	}
	.ant-select-selection-overflow {
		gap: 4px;
	}
`;
function Select(props) {
    return (0, jsx_runtime_1.jsx)(StyledSelect, { ...defaultProps, ...props });
}
Select.Option = antd_1.Select.Option;
Select.OptGroup = antd_1.Select.OptGroup;
const defaultProps = {
    tagRender: tagProps => (0, jsx_runtime_1.jsx)(SelectTag_1.SelectTag, { ...tagProps }),
};
